import { createAction, props } from '@ngrx/store';
import {
  ExtendedBaseInterface,
  ISearchRequest,
  PayrollSubmissions,
  UpdateAgentPayrollStatus,
  User,
} from './auth.models';

export enum ActionTypes {
  GET_AGENT_PAYROLL_SUBMISSIONS = '[Agent] Get Agent Payroll Submissions',
  GET_AGENT_PAYROLL_SUBMISSIONS_SUCCESS = '[Agent] Get Agent Payroll Submissions Success',
  GET_AGENT_PAYROLL_SUBMISSIONS_FAILURE = '[Agent] Get Agent Payroll Submissions Failure',

  SET_SHARED_DATA = '[Shared] Set Shared Data',

  GET_AGENT_PAYROLL_SUBMISSION_DETAILS = '[Agent] Get Agent Payroll Submission Details',
  GET_AGENT_PAYROLL_SUBMISSION_DETAILS_SUCCESS = '[Agent] Get Agent Payroll Submission Details Success',
  GET_AGENT_PAYROLL_SUBMISSION_DETAILS_FAILURE = '[Agent] Get Agent Payroll Submission Details Failure',

  UPDATE_AGENT_PAYROLL_SUBMISSION_STATUS = '[Agent] Update Agent Payroll Submission Status',
  UPDATE_AGENT_PAYROLL_SUBMISSION_STATUS_SUCCESS = '[Agent] Update Agent Payroll Submission Status Success',
  UPDATE_AGENT_PAYROLL_SUBMISSION_STATUS_FAILURE = '[Agent] Update Agent Payroll Submission Status Failure',
}

// Register action
export const Register = createAction(
  '[Authentication] Register',
  props<{ email: string; first_name: string; password: string }>()
);
export const RegisterSuccess = createAction(
  '[Authentication] Register Success',
  props<{ user: User }>()
);
export const RegisterFailure = createAction(
  '[Authentication] Register Failure',
  props<{ error: string }>()
);

// login action
export const login = createAction(
  '[Authentication] Login',
  props<{ email: string; password: string }>()
);
export const loginSuccess = createAction('[Authentication] Login Success');
export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: string }>()
);

// logout action
export const logout = createAction('[Authentication] Logout');

export const logoutSuccess = createAction('[Auth] Logout Success');

export const getAgentPayrollSubmissions = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSIONS,
  props<{ data: ISearchRequest }>()
);

export const getAgentPayrollSubmissionsSuccess = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSIONS_SUCCESS,
  props<{ data: any }>()
);

export const getAgentPayrollSubmissionsFailure = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSIONS_FAILURE,
  props<{ error: any }>()
);

export const setSharedData = createAction(
  ActionTypes.SET_SHARED_DATA,
  props<{ data: ExtendedBaseInterface }>()
);

export const getAgentPayrollSubmissionDetails = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSION_DETAILS,
  props<{ id: number }>()
);

export const getAgentPayrollSubmissionDetailsSuccess = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSION_DETAILS_SUCCESS,
  props<{ data: PayrollSubmissions }>()
);

export const getAgentPayrollSubmissionDetailsFailure = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSION_DETAILS_FAILURE,
  props<{ error: any }>()
);

export const updateAgentPayrollSubmissionStatus = createAction(
  ActionTypes.UPDATE_AGENT_PAYROLL_SUBMISSION_STATUS,
  props<{ data: UpdateAgentPayrollStatus }>()
);

export const updateAgentPayrollSubmissionStatusSuccess = createAction(
  ActionTypes.UPDATE_AGENT_PAYROLL_SUBMISSION_STATUS_SUCCESS,
  props<{ data: any }>()
);

export const updateAgentPayrollSubmissionStatusFailure = createAction(
  ActionTypes.UPDATE_AGENT_PAYROLL_SUBMISSION_STATUS_FAILURE,
  props<{ error: any }>()
);
